import { Box, styled } from '@mui/material';

export const OptionWrapper = styled(Box)({
  display: 'flex',
  width: '100%'
});

export const ShowMoreOption = styled(Box)({
  fontStyle: 'italic'
});

export const RegularOption = styled(Box)({
  position: 'relative',
  width: '100%'
});

export const OptionDisplayWrapper = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  marginRight: theme.spacing(7.5),
  display: 'flex',
  justifyContent: 'space-between'
}));

export const OptionIconWrapper = styled(Box)(({ theme }) => ({
  width: theme.spacing(5),
  position: 'absolute',
  right: '-10px',
  top: '-2px'
}));
